module.exports = __webpack_public_path__ + "gi.db3602c0bbd16f045732.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/gi.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/gi.svg
// module chunks = styles